import React, { PropsWithChildren, useState } from 'react';
import { Row, Col } from 'reactstrap';
import './index.css';
import { useTimeout } from '../../../../containers/useTimeout/useTimeout';

export type ItemContainerProps = { pulsing?: boolean; className?: string };

const ItemContainer = ({
  children,
  pulsing,
  className,
}: PropsWithChildren<ItemContainerProps>) => {
  let [shouldPulse, setPulse] = useState(pulsing);
  let [deboucing, setDebouce] = useState(false);
  useTimeout(() => setPulse(false), deboucing ? 1000 : null);
  const rowClassName = `item-container${shouldPulse ? ' pulse' : ''}${
    className ? ` ${className}` : ''
  }`;
  return (
    <Row
      noGutters
      className={rowClassName}
      onMouseEnter={() => setDebouce(true)}
      onMouseLeave={() => setDebouce(false)}
      onMouseDown={() => setPulse(false)}>
      <Col>{children}</Col>
    </Row>
  );
};

export default ItemContainer;
